import { useDispatch, useSelector } from 'react-redux';
import { DoubleArrowLeft, DoubleArrowRight } from '@rsos/assets/icons';
import { useFlag } from '@rsos/flags';
import { toggleQueueCollapse } from '@rsos/reduxDataStore/src/features/queue/queueSlice';
import useHasAccessToUniteEventPane from '../../../../hooks/useHasAccessToUniteEventPane';
import { ActionBarItem } from '../ActionBarItem';

const CollapseQueueActionBarItem = () => {
  const isCollapseQueueEnabled = useFlag('collapse_queue');
  const dispatch = useDispatch();
  const hasAccessToUniteEventPane = useHasAccessToUniteEventPane();
  const isCollapsed = useSelector(state => state.queue?.isQueueCollapsed);

  const handleCollapseQueue = () => {
    dispatch(toggleQueueCollapse());
  };

  if (!isCollapseQueueEnabled) {
    return null;
  }

  return (
    <ActionBarItem
      id="action-bar-item-collapse"
      onClick={handleCollapseQueue}
      tooltipText={isCollapsed ? 'Expand queue' : 'Collapse queue'}
      shouldRender={hasAccessToUniteEventPane}
    >
      {isCollapsed ? <DoubleArrowRight /> : <DoubleArrowLeft />}
    </ActionBarItem>
  );
};

export default CollapseQueueActionBarItem;
